import { CountryCodeEnum } from '@/enums/country-code-enum';

// SCRUM-1576: países onde o CAPTCHA é dispensado no front (Rússia, China e Turquia).
export const CAPTCHA_EXEMPT_COUNTRIES: readonly CountryCodeEnum[] = [CountryCodeEnum.RUSSIAN, CountryCodeEnum.CHINESE, CountryCodeEnum.TURKEY];

// Token sentinela enviado quando o CAPTCHA é dispensado, apenas para satisfazer a validação
// `recaptcha.required()` dos formulários. O backend ignora a validação para esses países com
// base na detecção de país por IP (server-side), então este valor nunca é verificado.
export const CAPTCHA_BYPASS_TOKEN = 'captcha-exempt-country';

// Key da feature toggle (remote config via /feature-toggle/check) que liga/desliga o bypass
// de CAPTCHA para os países isentos sem precisar de deploy. Deve estar registrada no backend
// com este mesmo nome; enquanto não existir/ativa, o hook retorna false (fail-safe = CAPTCHA ligado).
export const CAPTCHA_BYPASS_TOGGLE_KEY = 'captcha_geo_bypass_enabled';
